import { PeriodKpi } from "@/api/periodData";
import { STAT_GROUPS } from "./periodDataUtils";
import { PeriodStatGroupCard } from "./PeriodStatGroupCard";

interface PeriodComparisonCardProps {
    period: number;
    homePeriod: PeriodKpi | undefined;
    awayPeriod: PeriodKpi | undefined;
    homeTeamName?: string;
    awayTeamName?: string;
}

export const PeriodComparisonCard = ({
    homePeriod,
    awayPeriod,
    homeTeamName,
    awayTeamName,
}: PeriodComparisonCardProps) => (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {STAT_GROUPS.map((group) => (
            <div key={group.label} className="flex flex-col gap-3">
                <h3 className="text-lg font-headline font-bold shrink-0" style={{ color: "#050066" }}>
                    {group.label}
                </h3>
                <PeriodStatGroupCard
                    group={group}
                    homePeriod={homePeriod}
                    awayPeriod={awayPeriod}
                    homeTeamName={homeTeamName}
                    awayTeamName={awayTeamName}
                />
            </div>
        ))}
    </div>
);
